import React, { useCallback, useRef, useState } from "react";
import SkeletonAllim from "../../../views/common/Skeleton/SkeletonAllim";
import AllimBox from "../../../views/NoticeBoard/Component/AllimBox";

export default props => {
  const { title, loading, allimList, deleteAlrm, goToUrl } = props;

  const PAGE_SIZE = 10; // 한 번에 불러올 데이터 개수

  const [visibleCount, setVisibleCount] = useState(PAGE_SIZE);
  const observerRef = useRef(null);

  // 마지막 요소 감지하여 더 많은 데이터 표시
  const lastElementRef = useCallback(
    node => {
      if (observerRef.current) observerRef.current.disconnect();

      observerRef.current = new IntersectionObserver(
        entries => {
          if (entries[0].isIntersecting) {
            setVisibleCount(prev =>
              Math.min(prev + PAGE_SIZE, allimList.length)
            );
          }
        },
        { threshold: 1.0 }
      );

      if (node) observerRef.current.observe(node);
    },
    [allimList.length]
  );

  return (
    <div>
      <div className={title.className}>
        <div className="title">
          <i className={title.iconClassName} /> {title.text}
        </div>

        {loading ? (
          <SkeletonAllim />
        ) : (
          allimList &&
          allimList.length > 0 &&
          allimList
            .slice(0, visibleCount)
            .map((m, i) => (
              <AllimBox
                allimData={m}
                deleteAlrm={deleteAlrm}
                goToUrl={goToUrl}
                key={"allimH" + i}
              />
            ))
        )}
      </div>
      {visibleCount < allimList.length && <div ref={lastElementRef} />}
    </div>
  );
};
